




























































































































import { Component, Vue } from 'vue-property-decorator';
import BaseComponent from '../../core/base.component';
import AnalysisSummary from './components/AnalysisSummary.vue';
import AnalysisSales from './components/AnalysisSales.vue';
import AnalysisCategory from './components/AnalysisCategory.vue';
import AnalysisPopulation from './components/AnalysisPopulation.vue';
import AnalysisMap from './components/AnalysisMap.vue';
import { AnalysisTabListDto, CompanyDistrictDto } from '@/dto';
import { ReverseQueryParamMapper } from '@/core';
import { BAEMIN_CATEGORY_CODE } from '@/services/shared';
import CompanyDistrictService from '@/services/company-district.service';
import CodeBdongService from '@/services/analysis/code-bdong.service';

@Component({
  name: 'Analysis',
  components: {
    AnalysisSummary,
    AnalysisSales,
    AnalysisCategory,
    AnalysisPopulation,
    AnalysisMap,
  },
})
export default class Analysis extends BaseComponent {
  private slidebarVisible = true;
  private bdongCode = null;
  private analysisTabSearchDto = new AnalysisTabListDto();
  private addressKeyword = '';
  private searched = false;
  private districtSelect = [];
  private comapnyDistrictDto = new CompanyDistrictDto();
  private queryParam: any;
  private summaryClicked = false;
  private revenueClicked = false;
  private categoryClicked = false;
  private populationClicked = false;
  private propDistrict = { lat: '37.5012283', lon: '127.0334121' };

  //서울에 있는 상권분석가능한 지역 동을 받아옴
  getDistrictAddress() {
    this.comapnyDistrictDto.region1DepthName = '서울';
    CompanyDistrictService.findForSelectOptionAnalysis(
      this.comapnyDistrictDto,
    ).subscribe(res => {
      // console.log('getDistrictAddress res', res);
      if (res) {
        this.districtSelect = res.data;
      }
    });
  }
  //법정동코드로 지역정보를 받아옴
  getReverseDistrict(bdongCode) {
    this.comapnyDistrictDto.region1DepthName = '서울';
    this.comapnyDistrictDto.bCode = bdongCode;
    CompanyDistrictService.findForSelectOption(
      this.comapnyDistrictDto,
    ).subscribe(res => {
      if (res) {
        // console.log('getReverseDistrict res', res);
        if (res.data && res.data[0]) {
          this.$set(this.propDistrict, 'lat', res.data[0].lat);
          this.$set(this.propDistrict, 'lon', res.data[0].lon);
        }
      }
    });
  }
  //주소를 법정동 코드로 바꿔줌
  findBdongCode() {
    this.searched = false;
    CodeBdongService.findAll({ bdongName: this.addressKeyword }).subscribe(
      res => {
        this.populationClicked = false;
        this.revenueClicked = false;
        this.summaryClicked = false;
        this.categoryClicked = false;
        this.bdongCode = res.data.items[0].bdongCode;
        // console.log('this.bdongCode', this.bdongCode);
        this.getReverseDistrict(this.bdongCode);
      },
    );
  }

  async search() {
    this.$router
      .push({
        query: Object.assign({
          bdongCode: this.bdongCode,
        }),
      })
      .catch(() => {
        console.log('search failed');
      });
    this.searched = true;
  }
  clickTabSummary() {
    this.summaryClicked = true;
    // this.$root.$emit('tabSummary');
  }
  clickTabRevenue() {
    this.revenueClicked = true;
    // this.$root.$emit('tabRevenue');
  }
  clickTabCategory() {
    this.categoryClicked = true;
    // this.$root.$emit('tabCategory');
  }
  clickTabPopulation() {
    this.populationClicked = true;
    // this.$root.$emit('tabPopulation');
  }

  removeCircles() {
    this.$root.$emit('removeCircles');
  }

  created() {
    this.getDistrictAddress();
    // this.queryParam = ReverseQueryParamMapper(location.search);
    // if (this.queryParam) {
    //   this.searched = true;
    //   this.search();
    //   this.clickTabSummary();
    // } else {
    //   this.searched = false;
    // }
  }
}
